import { Pathnames } from '~/components/v2/constants/pathnames';
import { Pathname } from '~/constants/pathname';
import { isPathnameOrNested } from '~/utils/isPathnameOrNested';

export const SEARCH_SUB_SIDE_NAV_PATHNAMES = [
  Pathnames.Search,
  Pathnames.RecentlyAdded,
  Pathnames.MyUploads,
  Pathnames.FavoriteItems,
  Pathnames.RecentlyModified,
  Pathnames.UnusedItems,
  Pathnames.UntaggedItems,
] as const;

export const isSearchSubSideNavPathname = (pathname: string) => {
  if (isPathnameOrNested(pathname, Pathname.SavedSearch)) {
    return true;
  }

  return SEARCH_SUB_SIDE_NAV_PATHNAMES.some((searchPathname) => isPathnameOrNested(pathname, searchPathname));
};
